import Button from "react-bootstrap/Button";
import "./index.scss";
import classNames from "classnames";

const PDLButton = ({ children, className = null, ...props }) => (
  <Button {...props} className={classNames('pdl_dna_button', className)}>{children}</Button>
);

export default PDLButton;
